import { createApp } from 'vue'
import App from './App.vue'

createApp(
  App,
  { mode: 1 }
).mount('#mercury-plugin-2')
createApp(
  App,
  { wrapper: '#mercury-plugin' }
).mount('#mercury-plugin')